import { Link, useLocation } from 'react-router-dom';
import { isNavLinkActive } from './navActive';

export default function HeaderNav() {
  const { pathname } = useLocation();

  const tierActive = isNavLinkActive(pathname, '/');
  const draftActive = isNavLinkActive(pathname, '/smart-draft');

  return (
    <nav className="header-nav" aria-label="主要メニュー">
      <Link
        to="/"
        className={`nav-link ${tierActive ? 'active' : ''}`}
      >
        ティア表
      </Link>
      <Link
        to="/smart-draft"
        className={`nav-link ${draftActive ? 'active' : ''}`}
      >
        スマートドラフト
      </Link>
    </nav>
  );
}
